<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <div class="label">商家ID：</div>
              <el-input
                class="input"
                v-model="filter.sid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">商户全称：</div>
              <el-input
                class="input"
                v-model="filter.name"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="btn" style="padding: 0 15px; width: auto" @click="addPay">
            +添加收款商户
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="name"
            align="center"
            label="商户全称"
          ></el-table-column>
          <el-table-column
            prop="sid"
            align="center"
            label="商家ID"
          ></el-table-column>
          <el-table-column
            prop="mid"
            align="center"
            label="商户号"
          ></el-table-column>
          <el-table-column
            prop="certSerialNum"
            align="center"
            label="证书序列号"
          ></el-table-column>
          <el-table-column
            prop="key"
            align="center"
            label="商户APIv3密钥"
          ></el-table-column>
          <el-table-column
            prop="serviceRate"
            align="center"
            label="服务费费率"
          ></el-table-column>
          <el-table-column
            prop="mode"
            align="center"
            label="支付方式"
          >
            <div slot-scope="scope">
              {{ modeMap[scope.row.mode] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="status"
            align="center"
            label="状态"
          >
          <div slot-scope="scope">
              {{ statusMap[scope.row.status] }}
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'record',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '收款商户',
        secondTitle: '收款商户'
      },
      filter: {
        sid: null,
        name: ''
      },
      list: [],
      statusMap: {
        1: '启用',
        2: '已停用'
      },
      modeMap: {
        wxPayMini: '微信小程序支付',
        wxPayApp: '微信APP支付',
        aliPayApp: '支付宝APP支付'
      }
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 获取留言板列表
    getList() {
      // return;
      this.loading++;
      this.httpGet(this.$root.getPayList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        sid: null,
        name: ''
      };
      this.getList();
    },
    addPay() {
      this.$router.push({
        name: 'addPay'
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
      }

      .import-btn {
        confirm-btn();
        height: 32px;
        padding: 0 15px;
        white-space: nowrap;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();

    .notice-input {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
